import React, { ReactNode } from 'react';
import { Stack, StackProps } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { I18NextNS } from 'src/models/Language.model';

export interface EmptyProps extends StackProps {
  children: ReactNode;
  text?: string;
}
export default function Empty({ children, text, ...props }: EmptyProps) {
  const { t } = useTranslation(I18NextNS.COMMON);

  return (
    <Stack className="d-flex align-items-center gap-5 mb-5" {...props}>
      <div className="text-center mt-5">
        <h1 data-test="no-matching-records">
          {text ?? t('message.error.noMatchingRecords')}
        </h1>
      </div>
      <div className="d-flex gap-4">{children}</div>
    </Stack>
  );
}
